import { EditHolidayListForm } from "./_components/edit-holiday-list-form";

const EditHolidayListPage = () => {
  return (
    <div className="p-3 max-h-[calc(100%-56px)] overflow-y-auto">
      <EditHolidayListForm />
      {/* <h1>Edit Holiday List Form</h1> */}
    </div>
  );
};

export default EditHolidayListPage;
